import {
  Box,
  Button,
  FormControl,
  TextField,
  Typography,
  IconButton,
  Tooltip,
  Grid
} from "@mui/material";
import HelpIcon from '@mui/icons-material/Help';
import { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CustomTextField from "../Components/CustomTextField";
import CustomSearchSelect from "../Components/CustomSearchSelect";
import TokenContext from "../context/TokenContext";
import { UserAuth } from "../context/AuthContext";
import { actualizacionLegajo, miLegajo } from "../Redux/legajo";
import Divider from '@mui/material/Divider';

const tipoDocumentoOpciones = [
  { value: 100000000, label: "D.N.I." },
  { value: 100000001, label: "L.C." },
  { value: 100000002, label: "L.E." },
  { value: 100000003, label: "D.E." },
  { value: 100000004, label: "Pasaporte" },
];
const estadoCivilOpciones = [
  { value: 100000000, label: "Casado" },
  { value: 100000001, label: "Soltero" },
  { value: 100000002, label: "Divorciado" },
  { value: 100000003, label: "Viudo" },
  { value: 100000004, label: "Concubinato" },
  { value: 100000005, label: "Separado" },
];
const generoOpciones = [
  { value: false, label: "Masculino" },
  { value: true, label: "Femenino" },
];

const FormularioLegajo = ({ legajo, paises, provincias, localidades }) => {
  const dispatch = useDispatch();
  const token = useContext(TokenContext);
  const { empleado } = UserAuth();

  const estadoActualizacion = useSelector((store) => store.legajo.estadoActualizacion);

  const methods = useForm({
    shouldUnregister: false,
    mode: "onChange",
    defaultValues: {
      new_nombredepila: "",
      new_usuariocanvas: "",
      new_apellidos: "",
      new_numerolegajo: "",
      new_tipodocumento: {},
      numeroDocumento: 0,
      new_cuitcuil: 0,
      genero: {},
      email: "",
      estadoCivil: {},
      telefonoMovil: 0,
      telefonoParticular: 0,
      extencionTefefonica: 0,
      tipoContratacion: {},
      fechaNacimiento: "",
      paisNacimiento: {},
      edad: 0,
      provinciaNacimiento: {},
      calle: "",
      nroCalle: 0,
      piso: "",
      depto: "",
      localidad: {},
      codigoPostal: 0,
      provincia: {},
      pais: {},
    },
  });

  const { handleSubmit, reset, setValue, formState } = methods;

  // Forma más resumida utilizando el operador spread
  useEffect(() => {
    if (legajo) {
      Object.keys(legajo).forEach((key) => {
        setValue(key, legajo[key]);
      });
    }
  }, [legajo, setValue]);

  const submitDatos = (datos) => {
    console.log(datos)
    dispatch(actualizacionLegajo(token, empleado.empleadoid, datos))
      .then((id) => {
        if (id.length > 0) {
          dispatch(miLegajo(token, empleado.empleadoid))
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <>
      <FormProvider {...methods}>
        {/* Datos Generales */}
        <Box sx={{ py: 4, backgroundColor: "inherit" }}>
          <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
            <Typography
              variant="h2"
              color="inherit"
              sx={{ fontSize: "1.2rem" }}
            >
              Datos Generales
            </Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="text"
                label="Nombre de pila"
                name="new_nombredepila"
                readOnly={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="text"
                label="Apellidos"
                name="new_apellidos"
                readOnly={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomSearchSelect
                options={tipoDocumentoOpciones}
                type="text"
                name="new_tipodocumento"
                lab="Tipo documento"
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="number"
                label="Nro. documento"
                name="numeroDocumento"
                readOnly={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="number"
                label="CUIT/CUIL"
                name="new_cuitcuil"
                readOnly={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="text"
                label="Usuario Canvas"
                name="new_usuariocanvas"
                readOnly={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="text"
                label="Nro. Legajo"
                name="new_numerolegajo"
                readOnly={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="text"
                label="Correo electrónico"
                name="email"
                readOnly={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="number"
                label="Teléfono movil"
                name="telefonoMovil"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="number"
                label="Teléfono particular"
                name="telefonoParticular"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={10}>
                  <CustomSearchSelect
                    options={estadoCivilOpciones}
                    type="text"
                    name="estadoCivil"
                    lab="Estado Civil"
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Tooltip title="Diríjase a Solicitudes para cambiar el estado civil" arrow={true}>
                    <IconButton size="large">
                      <HelpIcon fontSize="large" />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>

            {/* <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="number"
                label="Extensión telefónica"
                name="extencionTefefonica"
              />
            </Grid> */}
          </Grid>

        </Box>
        <Divider />
        {/* Datos de Nacimiento */}
        <Box sx={{ py: 4, mt: 2, backgroundColor: "inherit" }}>
          <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
            <Typography
              variant="h2"
              color="inherit"
              sx={{ fontSize: "1.2rem" }}
            >
              Datos de Nacimiento
            </Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="date"
                label="Fecha nacimiento"
                name="fechaNacimiento"
                readOnly={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomSearchSelect
                options={paises}
                type="text"
                name="paisNacimiento"
                lab="País nacimiento"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="number"
                label="Edad"
                name="edad"
                readOnly={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomSearchSelect
                options={provincias}
                type="text"
                name="provinciaNacimiento"
                lab="Provincia nacimiento"
              />
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* Último Domicilio */}
        <Box sx={{ py: 4, mt: 2, backgroundColor: "inherit" }}>
          <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
            <Typography
              variant="h2"
              color="inherit"
              sx={{ fontSize: "1.2rem" }}
            >
              Último Domicilio
              <Tooltip title="Diríjase a Solicitudes para actualizar el domicilio" arrow={true}>
                <IconButton size="large">
                  <HelpIcon fontSize="large" />
                </IconButton>
              </Tooltip>
            </Typography>

          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="text"
                label="Calle"
                name="calle"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="number"
                label="Nro."
                name="nroCalle"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="text"
                label="Piso"
                name="piso"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="text"
                label="Depto."
                name="depto"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomSearchSelect
                options={localidades}
                type="text"
                name="localidad"
                lab="Localidad"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTextField
                Component={TextField}
                type="number"
                label="Código Postal"
                name="codigoPostal"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomSearchSelect
                options={provincias}
                type="text"
                name="provincia"
                lab="Provincia"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomSearchSelect
                options={paises}
                type="text"
                name="pais"
                lab="País"
                disabled
              />
            </Grid>
          </Grid>
        </Box>
      </FormProvider>
      <Box
        sx={{
          mt: 2,
          mb: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          type="button"
          onClick={handleSubmit(submitDatos)}
          variant="contained"
          sx={{ position: "relative" }}
          disabled={estadoActualizacion === "LOADING"}
        >
          Actualizar
        </Button>
      </Box>
    </>
  );
};

export default FormularioLegajo;
